<!-- Top Bar -->
<div class="top-bar">
  <div class="container top-bar-content">
    <div class="contact-info">
      <a href="tel:+918801237799">
        <i class="fas fa-phone-alt"></i>
        <span>8801237799</span>
      </a>
      <a href="mailto:info&#64;yukthatag.com">
        <i class="fas fa-envelope"></i>
        <span>info&#64;yukthatag.com</span>
      </a>
    </div>
    <div class="social-links">
      <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
      <a href="#" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
      <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
    </div>
  </div>
</div>

<!-- Main Navigation -->
<nav class="navbar" [class.scrolled]="isScrolled">
  <div class="container nav-content">

    <!-- Logo -->
    <a routerLink="/" class="logo">
      <img src="assets/images/yukthatag.webp" alt="Yuktha Associates Group" class="logo-img">
    </a>

    <!-- Desktop nav links -->
    <ul class="nav-links">
      <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a></li>
      <li><a routerLink="/about" routerLinkActive="active">About Us</a></li>
      <li class="dropdown">
        <a routerLink="/services" routerLinkActive="active">Services <i class="fas fa-chevron-down"></i></a>
        <ul class="dropdown-menu">
          <li><a routerLink="/services" fragment="defense">Defense & Railway Contracting</a></li>
          <li><a routerLink="/services" fragment="transformer">Transformers & Electrical Equipment</a></li>
          <li><a routerLink="/services" fragment="stockmarket">Stock Market Partnerships</a></li>
          <li><a routerLink="/services" fragment="importexport">Import & Export Solutions</a></li>
          <li><a routerLink="/services" fragment="realestate">Real Estate & Home Loans</a></li>
          <li><a routerLink="/services" fragment="insurance">Insurance Services</a></li>
        </ul>
      </li>
      <li><a routerLink="/solutions">Solutions</a></li>
      <li><a routerLink="/team">Our Team</a></li>
      <li><a routerLink="/contact" routerLinkActive="active">Contact Us</a></li>

      <!-- Auth -->
      @if (firebaseService.currentUser$ | async; as user) {
        <li class="nav-auth profile-dropdown">
          <button class="profile-btn" (click)="toggleProfileMenu()">
            @if (user.photoURL) {
              <img [src]="user.photoURL" [alt]="user.displayName || 'Profile'" class="profile-avatar">
            } @else {
              <div class="profile-avatar-placeholder"><i class="fas fa-user"></i></div>
            }
            <span class="profile-name">{{ user.displayName || (user.email ? user.email.split('@')[0] : 'User') }}</span>
            <i class="fas fa-chevron-down chevron" [class.open]="profileMenuOpen"></i>
          </button>
          @if (profileMenuOpen) {
            <div class="profile-menu">
              <div class="profile-menu-header">
                <p class="profile-menu-name">{{ user.displayName || 'User' }}</p>
                <p class="profile-menu-email">{{ user.email }}</p>
              </div>
              <div class="profile-menu-divider"></div>
              <a routerLink="/profile" class="profile-menu-item" (click)="profileMenuOpen = false">
                <i class="fas fa-user-circle"></i> My Profile
              </a>
              <a routerLink="/dashboard" class="profile-menu-item" (click)="profileMenuOpen = false">
                <i class="fas fa-tachometer-alt"></i> Dashboard
              </a>
              <div class="profile-menu-divider"></div>
              <button class="profile-menu-item logout" (click)="logout()">
                <i class="fas fa-sign-out-alt"></i> Logout
              </button>
            </div>
          }
        </li>
      } @else {
        <li class="nav-auth">
          <a routerLink="/login" class="btn-login">Login</a>
        </li>
      }
    </ul>

    <!-- Hamburger button (mobile only) -->
    <button class="mobile-toggle" (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuOpen"
      aria-label="Toggle navigation menu">
      <span [class.open]="mobileMenuOpen"></span>
      <span [class.open]="mobileMenuOpen"></span>
      <span [class.open]="mobileMenuOpen"></span>
    </button>
  </div>
</nav>

<!-- ─── Mobile Drawer ──────────────────────────── -->
<div class="mobile-drawer" [class.open]="mobileMenuOpen">

  <!-- Drawer header with logo + close -->
  <div class="drawer-header">
    <a routerLink="/" class="drawer-logo" (click)="closeMobileMenu()">
      <img src="assets/images/yukthatag.webp" alt="Yuktha Associates Group">
    </a>
    <button class="drawer-close" (click)="closeMobileMenu()" aria-label="Close menu">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Drawer nav links -->
  <nav class="drawer-nav">
    <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
       (click)="closeMobileMenu()">
      <i class="fas fa-home"></i> Home
    </a>
    <a routerLink="/about" routerLinkActive="active" (click)="closeMobileMenu()">
      <i class="fas fa-info-circle"></i> About Us
    </a>

    <!-- Services accordion -->
    <div class="drawer-accordion" [class.open]="servicesOpen">
      <button class="drawer-accordion-btn" (click)="servicesOpen = !servicesOpen">
        <span><i class="fas fa-concierge-bell"></i> Services</span>
        <i class="fas fa-chevron-down acc-arrow"></i>
      </button>
      <div class="drawer-accordion-body">
        <a routerLink="/services" fragment="defense" (click)="closeMobileMenu()">Defense & Railway Contracting</a>
        <a routerLink="/services" fragment="transformer" (click)="closeMobileMenu()">Transformers & Electrical Equipment</a>
        <a routerLink="/services" fragment="stockmarket" (click)="closeMobileMenu()">Stock Market Partnerships</a>
        <a routerLink="/services" fragment="importexport" (click)="closeMobileMenu()">Import & Export Solutions</a>
        <a routerLink="/services" fragment="realestate" (click)="closeMobileMenu()">Real Estate & Home Loans</a>
        <a routerLink="/services" fragment="insurance" (click)="closeMobileMenu()">Insurance Services</a>
      </div>
    </div>

    <a routerLink="/solutions" routerLinkActive="active" (click)="closeMobileMenu()">
      <i class="fas fa-lightbulb"></i> Solutions
    </a>
    <a routerLink="/team" routerLinkActive="active" (click)="closeMobileMenu()">
      <i class="fas fa-users"></i> Our Team
    </a>
    <a routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">
      <i class="fas fa-envelope"></i> Contact Us
    </a>
  </nav>

  <!-- Drawer footer auth -->
  <div class="drawer-footer">
    @if (firebaseService.currentUser$ | async; as user) {
      <div class="drawer-user">
        <div class="drawer-user-avatar">
          @if (user.photoURL) {
            <img [src]="user.photoURL" [alt]="user.displayName || 'User'">
          } @else {
            <i class="fas fa-user"></i>
          }
        </div>
        <div class="drawer-user-info">
          <p class="name">{{ user.displayName || 'User' }}</p>
          <p class="email">{{ user.email }}</p>
        </div>
      </div>
      <div class="drawer-user-actions">
        <a routerLink="/profile" (click)="closeMobileMenu()">
          <i class="fas fa-user-circle"></i> My Profile
        </a>
        <a routerLink="/dashboard" (click)="closeMobileMenu()">
          <i class="fas fa-tachometer-alt"></i> Dashboard
        </a>
        <button class="drawer-logout" (click)="logout(); closeMobileMenu()">
          <i class="fas fa-sign-out-alt"></i> Logout
        </button>
      </div>
    } @else {
      <a routerLink="/login" class="drawer-login-btn" (click)="closeMobileMenu()">
        <i class="fas fa-sign-in-alt"></i> Login to Your Account
      </a>
      <a routerLink="/register" class="drawer-register-btn" (click)="closeMobileMenu()">
        Create Account
      </a>
    }
  </div>
</div>

<!-- Backdrop -->
@if (mobileMenuOpen) {
  <div class="mobile-backdrop" (click)="closeMobileMenu()"></div>
}
